let tenantHelperSingleton;

const tenantHelperFactory = function() {
  function TenantHelper() {
    this.tenant = '';
    tenantHelperSingleton = this;
  }

  TenantHelper.prototype.getTenant = function() {
    if (!this.tenant) throw new Error('You forgot to call setTenant first');
    return this.tenant;
  };

  TenantHelper.prototype.setTenant = function(tenant) {
    this.tenant = tenant;
  };

  return tenantHelperSingleton ? tenantHelperSingleton : new TenantHelper();
};

tenantHelperFactory();

export { tenantHelperSingleton as tenantHelper };
